import React from "react";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import "../styles/landing.css";

export default function PublicLayout({ children }) {
  return (
    <div className="public-layout">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
